import { loadCards } from './domStructure/doorWindowsCards.js'
import { onClickWhatsapp } from './clickEvents.js'
import { createBannerComponent } from './domStructure/generics.js'
import { createCopyrightAndCreatorSection } from './domStructure/footer.js'
// import { resizeWindowHandler } from './utils/windowResize'

window.onload = function () {
    createBannerComponent("DOORS", "h1", document.querySelector('#bannerId'))

    const NUM_DOORS = 4
    const DOOR_ID_PREFIX = 'doorCardType'
    const sectionDoors = document.querySelector('#doorTypes')
    const colClassList = ["col-lg-3", "col-md-6"]
    const cardObj = { cardTypePrefix: DOOR_ID_PREFIX, numCards: NUM_DOORS, classList: ["card-my2"] }
    loadCards(sectionDoors, colClassList, cardObj, `${fantastic_windows_vars.api_url}/assets/JSON/doors.json`, false, "doors")

    const copyrightAndCreatorsJson = ""
    const copyrightAndCreatorSection = document.querySelector('#copyright-and-creators-id')
    createCopyrightAndCreatorSection(copyrightAndCreatorSection, copyrightAndCreatorsJson)
}

document.querySelector('#whatsapp-icon').addEventListener('click', (e) => {
    onClickWhatsapp()
})


const $dropdown = $(".dropdown")
const $dropdownToggle = $(".dropdown-toggle")
const $dropdownMenu = $(".dropdown-menu")
const showClass = "show"
// $(window).on("load resize", function() {
//     resizeWindowHandler(this, $(this), $dropdown, $dropdownToggle, $dropdownMenu, showClass)
// })
$(window).on("load resize", function () {
    if (this.matchMedia("(min-width: 768px)").matches) {
        $dropdown.hover(
            function () {
                const $this = $(this);
                $this.addClass(showClass);
                $this.find($dropdownToggle).attr("aria-expanded", "true");
                $this.find($dropdownMenu).addClass(showClass);
            },
            function () {
                const $this = $(this);
                $this.removeClass(showClass);
                $this.find($dropdownToggle).attr("aria-expanded", "false");
                $this.find($dropdownMenu).removeClass(showClass);
            }
        )
    } else {
        $dropdown.off("mouseenter mouseleave");
    }
})
